import React from 'react'
// @src imports
import connect from 'src/redux/connect'
import { Transition } from 'src/chrome'
import { PricingRoute } from 'src/marketing/plans/routes/PricingRoute'
import {
  GetMarketingParagraphs,
  GetMarketingParagraphsData,
  GetPlans,
} from 'src/graphql'
// relative imports
import { PlansDescription } from '../types'
import {
  AccountStorage,
  AutomatedSendsGrid,
  BasicPlan,
  PlanAddons,
  PlanContentsGrid,
  Plans,
  WaysToSend,
} from '../components'

import { openApp } from 'src/helpers/appHelpers'
import { performOperation } from 'src/app/api'
import { PromptingsPackageUpsale } from 'src/chrome/PromptingsPackageUpsale/PromptingsPackageUpsale'

type RoutesActions = {
  openCampaignStore?: () => void
}

type PricingProps = {
  route?: PricingRoute
  screenWidth?: number
  isMobile?: boolean
  sponsorId?: string
} & RoutesActions

type State = {
  plansDescriptions: PlansDescription[]
  plansDescriptionsStatus: 'init' | 'loading' | 'loaded' | 'error'
  marketingParagraphs?: GetMarketingParagraphsData
  marketingParagraphsStatus: 'init' | 'loading' | 'loaded' | 'error'
}

const initialState: State = {
  plansDescriptions: [],
  plansDescriptionsStatus: 'init',
  marketingParagraphs: undefined,
  marketingParagraphsStatus: 'init',
}

class Pricing extends React.Component<PricingProps, State> {
  state: State = {
    ...initialState,
  }

  showPlanUpgrade = (planId: string) => {
    // need to modify promo query param to be plan id
    openApp('', { join: '', promo: planId, planSelected: '' })
  }

  showPlanAddonBuy = (planAddonId: string) => {
    openApp('', { join: '', promo: planAddonId, planSelected: '' })
  }

  componentWillUnmount() {
    window.localStorage.removeItem('join-page')
  }

  componentDidMount() {
    if (this.state.plansDescriptionsStatus === 'init') {
      this.setState({ plansDescriptionsStatus: 'loading' })
      performOperation(GetPlans(), result => {
        if (result.error || !result.value) {
          this.setState({
            plansDescriptions: [],
            plansDescriptionsStatus: 'error',
          })
        } else {
          this.setState({
            plansDescriptions: result.value.plans
              .filter(p => !p.isAddon && p.description)
              .map(PlansDescription.fromPlanFragment)
              .sort(
                (a, b) =>
                  (a.description?.order ?? 10_000) -
                  (b.description?.order ?? 10_000),
              ),
            plansDescriptionsStatus: 'loaded',
          })
        }
      })
    }
    if (this.state.marketingParagraphsStatus === 'init') {
      this.setState({ marketingParagraphsStatus: 'loading' })
      performOperation(GetMarketingParagraphs(), result => {
        if (result.error || !result.value) {
          this.setState({
            marketingParagraphs: undefined,
            marketingParagraphsStatus: 'error',
          })
        } else {
          this.setState({
            marketingParagraphs: result.value,
            marketingParagraphsStatus: 'loaded',
          })
        }
      })
    }
  }

  render() {
    if (
      this.state.plansDescriptionsStatus === 'init' ||
      this.state.plansDescriptionsStatus === 'loading' ||
      this.state.marketingParagraphsStatus === 'init' ||
      this.state.marketingParagraphsStatus === 'loading'
    ) {
      return <Transition message="Loading plans..." />
    }

    const basicPlan = this.state.plansDescriptions.find(p => p.id === '1')

    return (
      <div>
        <Plans
          plansDescriptions={this.state.plansDescriptions}
          pricingTitle={
            this.state.marketingParagraphs?.pricingPageTitle.content
          }
          pricingSubtitle={
            this.state.marketingParagraphs?.pricingPageSubtitle.content
          }
          onSelect={this.showPlanUpgrade}
        />
        <PromptingsPackageUpsale
          sponsorId={this.props.sponsorId}
          isMobile={this.props.isMobile}
        />
        <PlanAddons
          isMobile={this.props.isMobile}
          onSelect={this.showPlanAddonBuy}
        />
        <BasicPlan basicPlan={basicPlan} onSelect={this.showPlanUpgrade} />
        <WaysToSend screenWidth={this.props.screenWidth} />
        <PlanContentsGrid />
        <AutomatedSendsGrid />
        <AccountStorage screenWidth={this.props.screenWidth} />
      </div>
    )
  }
}

export default connect(state => {
  return {
    screenWidth: state.window.width,
    isMobile: state.window.isMobile,
    sponsorId: state.storefront.sponsorSlug
      ? state.storefront.sponsorSlug
      : state.storefront.storefront?.user.genealogyId.toString(),
  }
}, {})(Pricing)
